import Vue from 'vue';

export default new Vue({
  methods : {
    frameworkBack(){
      this.$emit('framework.back');
    },
    frameworkNext(){
      this.$emit('framework.next');
    },
    frameworkButtonState(next=true,back=true){
      this.$emit('framework.disable_buttons',{next,back});
    },
    frameworkNavigationDisplay(show=true){
      this.$emit('framework.buttons_show',show);
    },
    changeFrameworkLocale(locale){
     this.$emit('language.change',locale);
    },
    playMedia(){
       this.$emit('media.play');
    },
    pauseMedia(){
       this.$emit('media.pause');
    },
    stopMedia(){
       this.$emit('media.stop');
    },
    forwardMedia(){
       this.$emit('media.skip_forward');
    },
    backwardMedia(){
       this.$emit('media.skip_backward');
    },
    restartMedia(){
       this.$emit('media.restart');
    },
    setMediaVolume(vol){
       this.$emit('media.volume_changed',vol);
    },
    showMediaSubtitles(show){
       this.$emit('media.show_subtitles',show);
    },
    journeyNext(){
      this.$emit('journey.next');
    },
    journeyBack(){
      this.$emit('journey.back');
    },
    playFrameworkSound(sound){
      this.$emit('sound',sound);
    },
    startVideoMonitoring(){
      this.$emit('video-monitoring-start');
    },
    stopVideoMonitoring(){
      this.$emit('video-monitoring-stop');
    },
    journeyPaused(){
      this.$emit('framework.pause.start');
    },
    journeyPauseResumed(){
      this.$emit('framework.pause.resume');
    },
    showQuestionTimer(timeInSeconds){
      this.$emit('framework.question.timer.show',timeInSeconds);
    },
    hideQuestionTimer(){
      this.$emit('framework.question.timer.hide');
    }
  }
});
